import { Analytics } from '@trello/atlassian-analytics';
import { HeaderTestIds } from '@trello/webdriverio-tests';
import { IconName } from 'app/common/components/controls/icon';
import React, { FunctionComponent, useCallback } from 'react';
import HeaderButton from 'app/gamma/src/components/header/button';
import { usePopover, Popover } from '@trello/nachos';
import { forNamespace } from 'app/common/lib/util/i18n';
const viewTitle = forNamespace('view title');
import { useFeatureFlag } from '@trello/feature-flag-client';
import { ActionableTaskInlineDialog } from './ActionableTaskInlineDialog';

export const ActionableTaskButton: FunctionComponent = () => {
  const { toggle, triggerRef, popoverProps } = usePopover<HTMLButtonElement>();

  const onClick = useCallback(() => {
    toggle();
    Analytics.sendUIEvent({
      action: 'clicked',
      actionSubject: 'button',
      actionSubjectId: 'actionableTaskButton',
      source: 'appHeader',
    });
  }, [toggle]);

  const showButton = useFeatureFlag('remarkable.actionable-view', false);

  if (!showButton) {
    return null;
  }

  return (
    <>
      <HeaderButton
        icon={IconName.Checklist}
        onClick={onClick}
        ref={triggerRef}
        testId={HeaderTestIds.ActionableTaskView}
      />
      <Popover
        {...popoverProps}
        title={viewTitle('your items beta')}
        size="large"
      >
        <ActionableTaskInlineDialog />
      </Popover>
    </>
  );
};
